import React, { useState } from "react";
import { Box, TextField, Typography, Modal, Popover } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SaveButton, CloseButton } from "../../../common/Buttons";
import Palette from "../../Plan/Palette";
import { ChromePicker } from "react-color";

const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: 24,
  padding: theme.spacing(4),
}));

function CreateItemModal({ table, handleAddItem }) {
  const creatingRow = table.getState().creatingRow || {};
  const handleSafetyStockChange = (e) => {
    const val = e.target.value;
    if (val === "") {
      table.setCreatingRow({
        ...creatingRow,
        safety_stock: "",
      });
      return;
    }
    const parsed = parseInt(val, 10);
    if (Number.isNaN(parsed)) return;
    const safeValue = parsed < 0 ? 0 : parsed;
    table.setCreatingRow({
      ...creatingRow,
      safety_stock: safeValue,
    });
  };
  const [activeColor, setActiveColor] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const onTileClick = (color) => {
    setActiveColor(color);
    table.setCreatingRow({
      ...creatingRow,
      gantt_color: color,
    });
  };
  const handleOpenChromePicker = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleInputChange = (field, value) => {
    setActiveColor(value);
  };
  const handleCloseChromePicker = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <Modal open={true}>
      <ModalContainer>
        <Typography variant="h6" component="h2" mb={3}>
          제품 추가
        </Typography>
        <TextField
          label="제품명"
          fullWidth
          name="item_name"
          value={creatingRow.item_name ?? ""}
          onChange={(e) =>
            table.setCreatingRow({
              ...creatingRow,
              item_name: e.target.value,
            })
          }
          sx={{ mb: 3 }}
        />
        <TextField
          label="Material Grouping"
          fullWidth
          name="material_grouping"
          value={creatingRow.material_grouping ?? ""}
          onChange={(e) =>
            table.setCreatingRow({
              ...creatingRow,
              material_grouping: e.target.value,
            })
          }
          sx={{ mb: 3 }}
        />
        <TextField
          label="안전재고"
          fullWidth
          name="safety_stock"
          type="number"
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            min: 0,
            step: 1,
          }}
          value={creatingRow.safety_stock ?? ""}
          onChange={handleSafetyStockChange}
          sx={{ mb: 3 }}
        />{" "}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            색상 선택
          </Typography>
          <Palette
            handleOpenChromePicker={handleOpenChromePicker}
            title="더 많은 색상 선택"
            handleInputChange={handleInputChange}
            colors1={[
              { value: "#96bef0" },
              { value: "#ffb5ea" },
              { value: "#8affad" },
              { value: "#9ccdff" },
              { value: "#ea9cfb", lightLabel: true },
              { value: "#f0be68", lightLabel: true },
              { value: "#64f0f0", lightLabel: true },
              { value: "#efb9b9", lightLabel: true },
              { value: "#6ff080", lightLabel: true },
              { value: "#b7e1f0", lightLabel: true },
            ]}
            colors2={[
              { value: "#ffd179" },
              { value: "#c5ff7b" },
              { value: "#64b9ff" },
              { value: "#d87570" },
              { value: "#aff3b2", lightLabel: true },
              { value: "#a2a6d8", lightLabel: true },
              { value: "#ffbe96", lightLabel: true },
              { value: "#c882e2", lightLabel: true },
              { value: "#c4a9d3", lightLabel: true },
              { value: "#aad2e8", lightLabel: true },
            ]}
            activeColor={activeColor}
            setActiveColor={setActiveColor}
            onTileClick={onTileClick}
          />
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseChromePicker}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Box sx={{ p: 2, backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
              <ChromePicker
                color={activeColor}
                onChangeComplete={(color) => {
                  handleInputChange("color", color.hex);
                  handleCloseChromePicker();
                }}
              />
            </Box>
          </Popover>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <SaveButton
            onClick={() =>
              handleAddItem({ values: table.getState().creatingRow, table })
            }
          />
          <CloseButton
            variant="outlined"
            onClick={() => table.setCreatingRow(null)}
            color="inherit"
          />
        </Box>
      </ModalContainer>
    </Modal>
  );
}

export default CreateItemModal;
